import { render } from "./menuInternas.vue?vue&type=template&id=f42891fa"
import script from "./menuInternas.vue?vue&type=script&lang=js"
export * from "./menuInternas.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/congreso_online/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__